<template>
  <div class="page-header py-5 bg-primary">
    <div class="container">
      <h4 class="fw-bold mb-0 font-caps text-center">{{ pageTitle ?  pageTitle : '&nbsp;'}}</h4>
      <p v-if="pageSubtitle" class="text-center mt-2 mb-0 text-white">{{ pageSubtitle }}</p>
    </div>
  </div>
</template>

<script>

export default {
  props: ["pageTitle", "pageSubtitle"],
  setup() {},
};
</script>

<style>
/* .page-header {
  background-color: #4460ca;
} */
.page-header h4 {
  color: #fff;
  text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
}
</style>